import { Button } from "@crew/ui/components/button";
import { errorHint } from "../../app/api";
import { useLogOut } from "./logout";

type LogOut = ReturnType<typeof useLogOut>;

/**
 * A failed sign out: what went wrong, and Try again. Nothing otherwise. A
 * block span, since it may sit inside a paragraph (the auth card's footer).
 */
export function LogOutFailed({ logOut, className }: { logOut: LogOut; className?: string }) {
  if (!logOut.error) return null;
  return (
    <span role="alert" className={`block ${className ?? ""}`}>
      Couldn't sign out: {errorHint(logOut.error)}{" "}
      <Button variant="link" className="h-auto p-0" onClick={() => logOut.mutate()}>
        Try again
      </Button>
    </span>
  );
}

/** "Signed in as …. Sign out", for pages without the sidebar. */
export function SignedInAs({ email }: { email: string }) {
  const logOut = useLogOut();
  return (
    <>
      Signed in as {email}.{" "}
      <Button
        variant="link"
        className="h-auto p-0"
        onClick={() => logOut.mutate()}
        disabled={logOut.isPending}
      >
        Sign out
      </Button>
      <LogOutFailed logOut={logOut} className="mt-2 text-destructive" />
    </>
  );
}
